import { v4 as uuid } from 'uuid';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import { DynamicAspect, ImageAspectRatio } from './ImageSettings';

export type BlockImageListItemSettings = {
  orientation: ImageOrientation;
  aspectRatio: ImageAspectRatio;
  dynamicAspect: DynamicAspect;
  fixedAspect: boolean;
};

class BlockImageListItemData {
  id: string;
  image: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockImageListItemData {
  export function make(image: BlockComponentImage): BlockImageListItemData {
    return {
      id: uuid(),
      image,
    };
  }

  export function getDefault(image = ''): BlockImageListItemData {
    return make(BlockComponentImage.make(image));
  }
}

export default BlockImageListItemData;
